import fetch from "../../utils/fetch";
import {
  GEORLI_SUBGRAPH_URL,
  SUBGRAPH_URL,
  ON_LEND,
  IN_INVENTORY,
  SERVER_BASE_URL,
  GOERLI_SCAN_API,
  ETHERSCAN_API_KEY,
  ROLES,
  CLAIMABLE,
  BORROWED,
  SANDBOX_CASE,
} from "../../constants";
import {
  getAllGuilds,
  getAllScholars,
  getBorrowedNfts,
  getBorrowersForLender,
  getCollectionWiseNfts,
  getCommonItemsArrayFromTwoArray,
  getNftContractMetadata,
  getNftImages,
  getRentedNftsFromLentNfts,
} from "../../utils/wallet/apiHelpers";
import {
  checkIfNftIsLent,
  getUniqueItems,
  mergeTowArrayItemsHavingCommonLendingId,
  settingCollections,
  updateStatusForRentedNfts,
} from "../../utils/formatters";
import {
  FETCH_ALL_LENDED_NFT_QUERY,
  FETCH_ALL_RENTED_NFTS_QUERY,
  FETCH_ALL_USERS,
  FETCH_ALL_USER_DIRECT_LENDED_NFTS_QUERY,
  FETCH_BORROWED_NFTS,
  FETCH_CLAIMABLE_NFTS,
  FETCH_MARKET_NFT_QUERY,
  FETCH_USER_RENTED_NFTS_QUERY,
} from "../../contract/contract-constant";
import { APIActionType } from "../action-types/APIActionType";
import { getBalance } from "../../contract";
import { dummyScholarCover, dummyScholarProfile } from "../../assets";
import { fetchTestnetHoldings } from "../../utils/holdings";

const ALCHEMY_API_KEY = "uZQ-N-ACmJP2S72X4Ave9TOENtpdDKkW";
const ALCHEMY_API_KEY_MAINNET = "Tu3xiIXyUIxu1h2GVFRFvT9Zp8bdHAla";
const ALCHEMY_BASE_URL_GOERLI = `https://eth-goerli.g.alchemy.com/v2/${ALCHEMY_API_KEY}`;
const ALCHEMY_BASE_URL_MAINNET = `https://eth-mainnet.g.alchemy.com/v2/${ALCHEMY_API_KEY_MAINNET}`;

const ALCHEMY = {
  1: {
    API_KEY: "Tu3xiIXyUIxu1h2GVFRFvT9Zp8bdHAla",
    BASE_URL: `https://eth-mainnet.g.alchemy.com/v2/${ALCHEMY_API_KEY_MAINNET}`,
  },
  5: {
    API_KEY: "uZQ-N-ACmJP2S72X4Ave9TOENtpdDKkW",
    BASE_URL: `https://eth-goerli.g.alchemy.com/v2/${ALCHEMY_API_KEY}`,
  },
};

export const getAllCollectionsFromServer = async () => {
  try {
    // Replace with your Alchemy API key:
    const baseURL = `${SERVER_BASE_URL}contracts`;
    // Replace with the wallet address you want to query:
    const fetchURL = `${baseURL}`;

    // Make the request and print the formatted response:
    return await fetch(fetchURL)
      .then((response) => {
        console.log("all nfts response from server", response);
        return response.payload;
      })
      .catch((error) => console.log("error", error));
  } catch (error) {
    console.log("err in fetching owned nfts from alchemy", error);
  }
};

export const addCollectionOnServer = async (collection) => {
  try {
    // Replace with your Alchemy API key:
    const baseURL = `${SERVER_BASE_URL}addContract`;
    // Replace with the wallet address you want to query:
    const fetchURL = `${baseURL}`;

    // Make the request and print the formatted response:
    return await fetch(fetchURL, collection, "post")
      .then((response) => {
        return response;
      })
      .catch((error) => console.log("error", error));
  } catch (error) {
    console.log("err in fetching owned nfts from alchemy", error);
  }
};

export const getContractMetadata = async (address, chainId) => {
  try {
    // Replace with your Alchemy API key:
    const baseURL = `${ALCHEMY[chainId].BASE_URL}/getContractMetadata`;
    // Replace with the wallet address you want to query:
    const fetchURL = `${baseURL}?contractAddress=${address}`;

    // Make the request and print the formatted response:
    return await fetch(fetchURL)
      .then((response) => {
        return response.payload;
      })
      .catch((error) => console.log("error", error));
  } catch (error) {
    console.log("err in fetching owned nfts from alchemy", error);
  }
};

const fetchOwnedNftsFromAlchemy = async (address, chainId) => {
  try {
    // Replace with your Alchemy API key:

    const baseURL = `${ALCHEMY[chainId].BASE_URL}/getNFTs/`;
    // Replace with the wallet address you want to query:
    // const ownerAddr = "0xF5FFF32CF83A1A614e15F25Ce55B0c0A6b5F8F2c";
    const fetchURL = `${baseURL}?owner=${address}`;

    // Make the request and print the formatted response:
    return await fetch(fetchURL)
      .then((response) => {
        console.log("response from alcemy owned", response);
        let responseNfts = response.payload.ownedNfts.map((nftO, index) => {
          if (nftO?.contract?.address === SANDBOX_CASE) {
            return {
              id: index + 1,
              name:
                nftO?.title ||
                nftO?.netadata?.name ||
                nftO?.contractMetadata?.name,
              nftAddress: nftO?.contract?.address,
              tokenId: parseInt(nftO?.id?.tokenId).toString(),
              description: nftO?.description || "",
              image: nftO?.media[0]?.thumbnail || nftO?.metadata?.image || "",
              status: IN_INVENTORY,
              contractAddress: nftO?.contract?.address,
              tokenSymbol: nftO?.contractMetadata?.symbol,
              symbol: nftO?.contractMetadata?.symbol,
              contractName: nftO?.contractMetadata?.name,
              contractType: nftO.contractMetadata.tokenType,
              balance: nftO.balance,
              properties: nftO?.metadata?.attributes || [],
            };
          } else {
            return {
              id: index + 1,
              name:
                nftO?.title ||
                nftO?.netadata?.name ||
                nftO?.contractMetadata?.name,
              nftAddress: nftO?.contract?.address,
              tokenId: parseInt(nftO?.id?.tokenId).toString(),
              description: nftO?.description || "",
              image: nftO?.metadata?.image || nftO?.metadata?.image_url || "",
              status: IN_INVENTORY,
              contractAddress: nftO?.contract?.address,
              tokenSymbol: nftO?.contractMetadata?.symbol,
              symbol: nftO?.contractMetadata?.symbol,
              contractName: nftO?.contractMetadata?.name,
              contractType: nftO.contractMetadata.tokenType,
              balance: nftO.balance,
              properties: nftO?.metadata?.attributes || [],
            };
          }
        });

        return responseNfts;
      })
      .catch((error) => console.log("error", error));
  } catch (error) {
    console.log("err in fetching owned nfts from alchemy", error);
  }
};

const getNftMetadataFromAlchemy = async (
  contractAddress,
  tokenId,
  tokenType,
  status,
  chainId
) => {
  try {
    // Replace with your Alchemy API key:
    const baseURL = `${ALCHEMY[chainId].BASE_URL}/getNFTMetadata`;
    // Replace with the wallet address you want to query:
    const fetchURL = `${baseURL}?contractAddress=${contractAddress}&tokenId=${tokenId}&tokenType=${tokenType}`;

    return await fetch(fetchURL)
      .then((response) => {
        let responseNft = response.payload;
        console.log("response.payload", response.payload);
        let modifiedNft = {
          contractType: responseNft.contractMetadata.tokenType,
          name:
            responseNft?.title ||
            responseNft?.metadata?.name ||
            responseNft?.contractMetadata?.name,
          contractName: responseNft?.contractMetadata?.name,
          symbol: responseNft?.contractMetadata?.symbol,
          tokenSymbol: responseNft?.contractMetadata?.symbol,
          nftAddress: responseNft?.contract.address,
          tokenId: parseInt(responseNft?.id?.tokenId).toString(),
          description:
            responseNft?.description ||
            responseNft?.metadata?.description ||
            "",
          image: responseNft?.metadata?.image || "",
          properties: responseNft?.metadata?.attributes || [],
          status,
        };

        return modifiedNft;
      })
      .catch((error) => console.log("error", error));
  } catch (err) {}
};

export const getNFTByUserAddress = (address, chainId) => async (dispatch) => {
  console.log("getNFTByUserAddress dispatcher start");
  try {
    let ownedNftsFromAlchemy = await fetchOwnedNftsFromAlchemy(
      address,
      chainId
    );
    let responseLentNfts = await fetch(
      GEORLI_SUBGRAPH_URL,
      {
        query: FETCH_ALL_LENDED_NFT_QUERY(address),
      },
      "post"
    );

    let responseRentedNfts = await fetch(
      GEORLI_SUBGRAPH_URL,
      {
        query: FETCH_ALL_RENTED_NFTS_QUERY,
      },
      "post"
    );

    let responseMarketNfts = await fetch(
      GEORLI_SUBGRAPH_URL,
      {
        query: FETCH_MARKET_NFT_QUERY(address),
      },
      "post"
    );

    const { allLendedNfts, userAllTimeBorrowedNfts } = await getBorrowedNfts(
      address
    );

    let marketNfts = responseMarketNfts?.payload?.data?.lends;
    const marketNftsTokenIds = marketNfts.map((nft) => nft.tokenIds);
    const marketNftsAddresses = marketNfts.map((nft) => nft.nftAddress);

    console.log("in profile", { marketNfts, userAllTimeBorrowedNfts });
    let allNftsFromSubgraph = responseLentNfts?.payload?.data?.lends;
    let allRentedNftsFromSubgraph = responseRentedNfts?.payload?.data?.rents;

    console.log("in profile", allNftsFromSubgraph);

    let lendedNftsWithMetadata = await Promise.all(
      allNftsFromSubgraph.map(async (nftL) => {
        const nftWithData = await getNftMetadataFromAlchemy(
          nftL.nftAddress,
          nftL.tokenId,
          Number(nftL?.lendAmount) > 0 ? "ERC1155" : "ERC721",
          ON_LEND,
          chainId
        );

        if (nftWithData) {
          return {
            ...nftWithData,
            ...nftL,
          };
        } else {
          return {
            ...nftL,
          };
        }
      })
    );

    if (allRentedNftsFromSubgraph && allRentedNftsFromSubgraph.length) {
      lendedNftsWithMetadata = updateStatusForRentedNfts(
        lendedNftsWithMetadata,
        allRentedNftsFromSubgraph
      );
    }

    let nftsForProfile = getUniqueItems(
      ownedNftsFromAlchemy,
      lendedNftsWithMetadata
    );

    // let nftsForProfile = [...ownedNftsFromAlchemy, ...lendedNftsWithMetadata];
    console.log("nftsForProfile before", nftsForProfile);
    nftsForProfile = nftsForProfile.filter((nft) => {
      return !marketNfts.some(
        (nftM) =>
          nft.tokenId === nftM.tokenId && nft.nftAddress === nftM.nftAddress
      );
    });
    console.log("nftsForProfile after", { nftsForProfile });
    let allDirectRentedNfts = await getUserAllDirectLendedNfts(address);

    let allDirectRentedNftsWithImages = mergeTowArrayItemsHavingCommonLendingId(
      nftsForProfile,
      allDirectRentedNfts
    );

    // let onlyErc721 = nftsForProfile?.filter(
    //   (nft) => nft.contractType !== "ERC1155"
    // );
    let onlyErc721 = [...nftsForProfile];
    const collectionWiseProfileNfts = await getCollectionWiseNfts(
      onlyErc721,
      chainId
    );

    console.log("collectionWiseProfileNfts", collectionWiseProfileNfts);

    dispatch({
      type: APIActionType.SET_PROFILE_NFTS,
      payload: onlyErc721,
    });
    dispatch({
      type: APIActionType.SET_CW_PROFILE_NFTS,
      payload: collectionWiseProfileNfts,
    });
    dispatch({
      type: APIActionType.SET_SCHOLAR_LIST_NFTS,
      payload: allDirectRentedNftsWithImages,
    });
    console.log(
      "getNFTByUserAddress SET_PROFILE_NFTS dispatcher end with success"
    );
  } catch (error) {
    console.log(
      "getNFTByUserAddress SET_PROFILE_NFTS dispatcher end with error"
    );
    console.log("Error => in get by user", error);
  }
};

export const getClaimableNfts = (address, chainId) => async (dispatch) => {
  try {
    let claimableNftsResponse = await fetch(
      GEORLI_SUBGRAPH_URL,
      {
        query: FETCH_CLAIMABLE_NFTS(address),
      },
      "post"
    );

    let borrowedNftsResponse = await fetch(
      GEORLI_SUBGRAPH_URL,
      {
        query: FETCH_BORROWED_NFTS(address),
      },
      "post"
    );
    let claimableNfts = claimableNftsResponse?.payload?.data?.lends;
    let borrowedNfts = borrowedNftsResponse?.payload?.data?.rents;
    let lendingIdsOfBorrowedNfts = borrowedNfts.map((nft) => nft.lendingId);
    console.log("claimableNftsResponse", {
      claimableNftsResponse,
      borrowedNftsResponse,
      borrowedNfts,
    });
    let claimableNftsWithMetadata = await Promise.all(
      claimableNfts.map(async (nftL) => {
        const nftWithData = await getNftMetadataFromAlchemy(
          nftL.nftAddress,
          nftL.tokenId,
          Number(nftL?.lendAmount) > 0 ? "ERC1155" : "ERC721",
          CLAIMABLE,
          chainId
        );

        if (nftWithData) {
          return {
            ...nftWithData,
            ...nftL,
          };
        } else {
          return {
            ...nftL,
          };
        }
      })
    );
    claimableNftsWithMetadata = claimableNftsWithMetadata.filter(
      (nft) => !lendingIdsOfBorrowedNfts.includes(nft.lendingId)
    );
    console.log("claimableNftsWithMetadata", claimableNftsWithMetadata);
    dispatch({
      type: APIActionType.SET_CLAIMABLE_NFTS,
      payload: claimableNftsWithMetadata,
    });
  } catch (e) {
    console.log("get claimable nfts dispatcher error", e);
  }
};

export const updateClaimableNfts =
  (lendingIds, claimable) => async (dispatch) => {
    try {
      console.log("lendingIds, claimable", lendingIds, claimable);
      const updatedClaimable = claimable.filter(
        (nft) => !lendingIds.includes(nft.lendingId)
      );

      console.log("updatedClaimable", updatedClaimable);
      dispatch({
        type: APIActionType.SET_CLAIMABLE_NFTS,
        payload: updatedClaimable,
      });
    } catch (e) {
      console.log("get claimable nfts dispatcher error", e);
    }
  };

export const updateProfileNfts =
  (nfts, tokenId, nftAddress, status, lendingId, chainId) =>
  async (dispatch) => {
    let updatedProfileNfts = await nfts.map((nft) => {
      if (nft.tokenId === tokenId && nft.nftAddress === nftAddress) {
        return {
          ...nft,
          status,
          lendingId,
        };
      } else {
        return nft;
      }
    });

    // console.log("updatedProfileNfts", updatedProfileNfts);

    const collectionWiseProfileNfts = await getCollectionWiseNfts(
      updatedProfileNfts,
      chainId
    );
    dispatch({
      type: APIActionType.SET_CW_PROFILE_NFTS,
      payload: collectionWiseProfileNfts,
    });

    dispatch({
      type: APIActionType.SET_PROFILE_NFTS,
      payload: updatedProfileNfts,
    });
  };

export const updateProfileNftsAfterTransfer =
  (nfts, tokenId, nftAddress, chainId) => async (dispatch) => {
    let updatedProfileNfts = await nfts.filter(
      (nft) => nft.tokenId !== tokenId && nfts.nftAddress !== nftAddress
    );

    const collectionWiseProfileNfts = await getCollectionWiseNfts(
      updatedProfileNfts,
      chainId
    );
    dispatch({
      type: APIActionType.SET_CW_PROFILE_NFTS,
      payload: collectionWiseProfileNfts,
    });

    dispatch({
      type: APIActionType.SET_PROFILE_NFTS,
      payload: updatedProfileNfts,
    });
  };

export const updateProfileNftsAfter1155Transfer =
  (nfts, chainId) => async (dispatch) => {
    const collectionWiseProfileNfts = await getCollectionWiseNfts(
      nfts,
      chainId
    );
    dispatch({
      type: APIActionType.SET_CW_PROFILE_NFTS,
      payload: collectionWiseProfileNfts,
    });

    dispatch({
      type: APIActionType.SET_PROFILE_NFTS,
      payload: nfts,
    });
  };

export const updateScholarListNfts =
  (nfts, tokenId, nftAddress) => async (dispatch) => {
    // console.log("nfts new", nfts);
    let updatedScholarListNfts = await nfts.filter(
      (nft) => nft.tokenId !== tokenId && nft.nftAddress !== nftAddress
    );

    // console.log("updatedScholarListNfts", updatedScholarListNfts);

    dispatch({
      type: APIActionType.SET_SCHOLAR_LIST_NFTS,
      payload: updatedScholarListNfts,
    });
  };

export const updateProfileNftsOnBulkLend =
  (nfts, chainId) => async (dispatch) => {
    // console.log("updatedProfileNfts in dispatcher", nfts);

    const collectionWiseProfileNfts = await getCollectionWiseNfts(
      nfts,
      chainId
    );
    dispatch({
      type: APIActionType.SET_CW_PROFILE_NFTS,
      payload: collectionWiseProfileNfts,
    });

    dispatch({
      type: APIActionType.SET_PROFILE_NFTS,
      payload: nfts,
    });
  };

export const updateMarketNfts = (nfts, lendingId) => async (dispatch) => {
  // console.log("nfts new", nfts);
  let updatedMarketNfts = nfts.filter((nft) => nft.lendingId !== lendingId);

  dispatch({
    type: APIActionType.SET_MARKET_NFTS,
    payload: updatedMarketNfts,
  });
};

export const getUserAllDirectLendedNfts = async (address) => {
  try {
    let allUserDirectLendedNftsResponse = await fetch(
      GEORLI_SUBGRAPH_URL,
      {
        query: FETCH_ALL_USER_DIRECT_LENDED_NFTS_QUERY(address),
      },
      "post"
    );

    let allRentedNftsResponse = await fetch(
      GEORLI_SUBGRAPH_URL,
      {
        query: FETCH_ALL_RENTED_NFTS_QUERY,
      },
      "post"
    );

    console.log("allUserDirectLendedNftsResponse", {
      allUserDirectLendedNftsResponse,
      allRentedNftsResponse,
    });

    let allUserDirectLendedNfts =
      allUserDirectLendedNftsResponse?.payload?.data?.lends;
    let allRentedNfts = allRentedNftsResponse?.payload?.data?.rents;
    // let allDirectRentedNftsLendingIds = allRentedNfts
    //   .filter((nft) => nft.type === "Direct")
    //   .map((nft) => nft.lendingId);

    console.log("allRentedNfts", {
      allUserDirectLendedNfts,
      allRentedNfts,
      // allDirectRentedNftsLendingIds,
    });
    let res = mergeTowArrayItemsHavingCommonLendingId(
      allUserDirectLendedNfts,
      allRentedNfts
    );

    return res;
  } catch (e) {
    console.log("errr in direct rented nfts", e);
  }
};

export const resetAPIData = () => (dispatch) => {
  dispatch({
    type: APIActionType.RESET_API_DATA,
  });
};

export const setAccountBalance = (userAddress) => async (dispatch) => {
  let bal = await getBalance(userAddress);
  let url = `${GOERLI_SCAN_API}?module=stats&action=ethprice&apikey=${ETHERSCAN_API_KEY}`;
  const response = await fetch(url);
  // console.log("balance in usd", response.payload.ethusd);
  console.log("balanceInUsd", response.payload.result.ethusd);
  const ethPrice = Number(response.payload.result.ethusd);
  const balanceInUsd = ethPrice * Number(bal);

  const balObj = { balance: bal, balanceInUsd };

  dispatch({
    type: APIActionType.SET_USER_BALANCE,
    payload: balObj,
  });
};

export const setConnectedAccount = (userAddress) => async (dispatch) => {
  let allGuilds = await getAllGuilds();
  let allScholars = await getAllScholars();
  console.log("allGuilds", allGuilds);
  const isConnectedAddressExists = allGuilds.find(
    (user) => user.guildAddress.toLowerCase() === userAddress.toLowerCase()
  );
  if (isConnectedAddressExists) {
    let borrowers = await getBorrowersForLender(userAddress);

    console.log("borrowers getBorrowersForLender ", borrowers);

    console.log("allScholars", allScholars, isConnectedAddressExists._id);
    let scholarsForConnectedGuild = allScholars.filter(
      (scholar) => scholar.guildId === isConnectedAddressExists._id
    );
    scholarsForConnectedGuild = scholarsForConnectedGuild.map((scholar) => {
      const scholarObj = {
        ...scholar,
        coverPic: scholar.coverPic || dummyScholarCover,
        profilePic: scholar.profilePic || dummyScholarProfile,
      };
      const scholarAsBorrower = borrowers.filter(
        (borrower) => borrower.borrowerEOA === scholar.scholarAddress
      );
      if (scholarAsBorrower.length > 0) {
        let totalBorrowedNfts = 0;
        scholarAsBorrower.forEach(
          (sab) =>
            (totalBorrowedNfts = totalBorrowedNfts + sab.lendingIds.length)
        );
        return {
          ...scholarObj,
          totalBorrowedNfts,
        };
      } else {
        return scholarObj;
      }
    });
    console.log(
      "scholarsForConnectedGuild",
      scholarsForConnectedGuild,
      isConnectedAddressExists._id
    );

    dispatch({
      type: APIActionType.SET_SCHOLARS,
      payload: scholarsForConnectedGuild,
    });

    dispatch({
      type: APIActionType.SET_CONNECTED_ACCOUNT,
      payload: {
        ...isConnectedAddressExists,
        role: ROLES.GUILD,
      },
    });
  } else {
    const connectedScholar = allScholars.find(
      (scholar) =>
        scholar.scholarAddress.toLowerCase() === userAddress.toLowerCase() &&
        !scholar.guildId
    );

    console.log("connectedScholar", connectedScholar);

    if (connectedScholar) {
      dispatch({
        type: APIActionType.SET_CONNECTED_ACCOUNT,
        payload: {
          ...connectedScholar,
          role: ROLES.SCHOLAR,
        },
      });
    } else {
      dispatch({
        type: APIActionType.SET_CONNECTED_ACCOUNT,
        payload: { role: ROLES.SCHOLAR },
      });
    }
  }
};

export const updateConnectedAccount = (accountObj) => async (dispatch) => {
  dispatch({
    type: APIActionType.SET_CONNECTED_ACCOUNT,
    payload: {
      ...accountObj,
      role: ROLES.GUILD,
    },
  });
};

export const updateScholars = (updatedScholars) => async (dispatch) => {
  dispatch({
    type: APIActionType.SET_SCHOLARS,
    payload: updatedScholars,
  });
};

export const addScholar = (scholars) => async (dispatch) => {
  dispatch({
    type: APIActionType.SET_SCHOLARS,
    payload: scholars,
  });
};

const getUsersFromSbgraph = async () => {
  const allUsersResponse = await fetch(
    GEORLI_SUBGRAPH_URL,
    {
      query: FETCH_ALL_USERS,
    },
    "post"
  );

  const allUsers = allUsersResponse?.payload?.data?.users;
  return allUsers;
};

export const getAllUsers = () => async (dispatch) => {
  let allUsersResponse = await fetch(
    GEORLI_SUBGRAPH_URL,
    {
      query: FETCH_ALL_USERS,
    },
    "post"
  );

  const allUsers = allUsersResponse?.payload?.data?.users;
  console.log("allUsers", allUsers);
  dispatch({
    type: APIActionType.SET_ALL_USER,
    payload: allUsers.length > 0 ? allUsers : [],
  });
};

export const updateAllUsers = (usersFromRedux) => async (dispatch) => {
  let allUsers = await getUsersFromSbgraph();

  var intervalVar = setInterval(async () => {
    allUsers = await getUsersFromSbgraph();
    let ifNewEntryFetched = allUsers.length > usersFromRedux.length;

    console.log("ifNewEntryFetched", { ifNewEntryFetched });

    if (ifNewEntryFetched) {
      console.log("allUsers", allUsers);
      dispatch({
        type: APIActionType.SET_ALL_USER,
        payload: allUsers.length > 0 ? allUsers : [],
      });
      clearInterval(intervalVar);
    }
  }, 5000);
};

// export const getAllLendedNfts = (userAddress) => async (dispatch) => {
//   // console.log("getAllLendedNfts start dispatcher");
//   try {
//     let response = await fetch(
//       GEORLI_SUBGRAPH_URL,
//       {
//         query: FETCH_MARKET_NFT_QUERY(userAddress),
//       },
//       "post"
//     );

//     let responseRentedNfts = await fetch(
//       GEORLI_SUBGRAPH_URL,
//       {
//         query: FETCH_ALL_RENTED_NFTS_QUERY,
//       },
//       "post"
//     );

//     let allRentedNftsFromSubgraph = responseRentedNfts?.payload?.data?.rents;
//     let marketNfts = response.payload.data?.lends;

//     // console.log("market and rented", allRentedNftsFromSubgraph, marketNfts);

//     if (marketNfts.length > 0) {
//       let nftsWithImageURIs = await Promise.all(
//         marketNfts.map(async (nftL) => {
//           const nftWithData = await getNftMetadataFromAlchemy(
//             nftL.nftAddress,
//             nftL.tokenId,
//             "ERC721"
//           );
//           console.log("getNftMetadataFromAlchemy", nftWithData);
//           // console.log("metaData", metaData);
//           if (nftWithData) {
//             return {
//               ...nftWithData,
//               ...nftL,
//             };
//           } else {
//             return {
//               ...nftL,
//             };
//           }
//         })
//       );

//       let nftsWithContractInfo;
//       if (nftsWithImageURIs && nftsWithImageURIs.length > 0) {
//         nftsWithContractInfo = await Promise.all(
//           nftsWithImageURIs.map(async (nft) => {
//             let resp = await getNftContractMetadata(nft.nftAddress);
//             let nftContractInfo = {
//               contractName: resp?.name,
//               tokenSymbol: resp?.token,
//             };
//             // console.log("nftContractInfo inside", nftContractInfo);
//             return {
//               ...nft,
//               ...nftContractInfo,
//             };
//           })
//         );
//       }

//       let allRentedNftsLendingIds = allRentedNftsFromSubgraph.map(
//         (nft) => nft.lendingId
//       );

//       // console.log(
//       //   "checking",
//       //   allRentedNftsLendingIds,
//       //   nftsWithContractInfo,
//       //   nftsWithContractInfo?.filter(
//       //     (nftM) => !allRentedNftsLendingIds.includes(nftM.lendingId)
//       //   )
//       // );

//       let detectAndRemoveBorrowedNfts;
//       let uniqueContractAddresses;
//       if (nftsWithContractInfo && nftsWithContractInfo.length > 0) {
//         detectAndRemoveBorrowedNfts = nftsWithContractInfo.filter(
//           (nftM) => !allRentedNftsLendingIds.includes(nftM.lendingId)
//         );
//         uniqueContractAddresses = Array.from(
//           new Set(detectAndRemoveBorrowedNfts.map((item) => item.nftAddress))
//         );

//         console.log("uniqueCOntractAddresses", uniqueContractAddresses);
//       }

//       let collections = await getAllCollectionsFromServer();

//       let addressesToAddOnServer = settingCollections(
//         uniqueContractAddresses,
//         collections
//       );

//       console.log("addressesToAddOnServer", addressesToAddOnServer);

//       // console.log(
//       //   "market and user rented",
//       //   detectAndRemoveBorrowedNfts,
//       //   nftsWithContractInfo
//       // );

//       dispatch({
//         type: APIActionType.SET_MARKET_NFTS,
//         payload: detectAndRemoveBorrowedNfts,
//       });
//       console.log("getAllLendedNfts SET_MARKET_NFTS end dispatcher with data");
//     }
//     console.log("getAllLendedNfts SET_MARKET_NFTS end dispatcher withOUT data");
//   } catch (error) {
//     console.log("getAllLendedNfts SET_MARKET_NFTS end dispatcher with ERROR");
//     console.log("Error => ping pong ", error);
//   }
// };

export const updateBorrowedNfts =
  (nfts, borrowedNfts, chainId) => async (dispatch) => {
    try {
      const updatedBorrowed = [...borrowedNfts, ...nfts];

      const collectionWiseBorrowedNfts = await getCollectionWiseNfts(
        updatedBorrowed,
        chainId
      );

      console.log("updatedClaimable", collectionWiseBorrowedNfts);
      dispatch({
        type: APIActionType.SET_BORROWED_NFTS,
        payload: updatedBorrowed,
      });
      dispatch({
        type: APIActionType.SET_CW_BORROWED_NFTS,
        payload: collectionWiseBorrowedNfts,
      });
    } catch (e) {
      console.log("get claimable nfts dispatcher error", e);
    }
  };

export const fetchHoldings = (address, chainId) => async (dispatch) => {
  try {
    const holdings = await fetchTestnetHoldings(address, chainId);
    console.log("holdings", holdings);

    dispatch({
      type: APIActionType.SET_HOLDINGS,
      payload: holdings,
    });
  } catch (e) {
    console.log("fetching holdings dispatcher error", e);
  }
};

export const getUserBorrowedNfts =
  (userAddress, chainId) => async (dispatch) => {
    // console.log("getUserBorrowedNfts", userAddress);
    try {
      const { allLendedNfts, userAllTimeBorrowedNfts } = await getBorrowedNfts(
        userAddress
      );
      console.log("outside", { allLendedNfts, userAllTimeBorrowedNfts });

      // const borrowedNfts = getCommonItemsArrayFromTwoArray(
      //   userAllTimeBorrowedNfts,
      //   allLendedNfts
      // );
      const borrow = mergeTowArrayItemsHavingCommonLendingId(
        allLendedNfts,
        userAllTimeBorrowedNfts
      );
      console.log("borrowedNfts", borrow);

      let borrowedNftsWithMetadata = await Promise.all(
        borrow.map(async (nftL) => {
          const nftWithData = await getNftMetadataFromAlchemy(
            nftL.nftAddress,
            nftL.tokenId,
            Number(nftL?.lendAmount) > 0 ? "ERC1155" : "ERC721",
            BORROWED,
            chainId
          );

          if (nftWithData) {
            return {
              ...nftWithData,
              ...nftL,
            };
          } else {
            return {
              ...nftL,
            };
          }
        })
      );

      console.log("borrowedNftsWithMetadata", borrowedNftsWithMetadata);

      const collectionWiseBorrowedNfts = await getCollectionWiseNfts(
        borrowedNftsWithMetadata,
        chainId
      );

      console.log("collectionWiseBorrowedNfts", collectionWiseBorrowedNfts);

      dispatch({
        type: APIActionType.SET_BORROWED_NFTS,
        payload: borrowedNftsWithMetadata,
      });

      dispatch({
        type: APIActionType.SET_CW_BORROWED_NFTS,
        payload: collectionWiseBorrowedNfts,
      });
      // if (response.payload.data?.users.length > 0) {
      //   let { rentedNfts } = response.payload.data.users[0];

      //   rentedNfts = rentedNfts.filter((nft) =>
      //     checkIfNftIsLent(nft.rentedAt, nft.rentDuration)
      //   );

      //   let nftsWithImageURIs = await getNftImages(rentedNfts);

      //   if (nftsWithImageURIs) {
      //     dispatch({
      //       type: APIActionType.SET_BORROWED_NFTS,
      //       payload: [nftsWithImageURIs[0]],
      //     });
      //   } else {
      //     dispatch({
      //       type: APIActionType.SET_BORROWED_NFTS,
      //       payload: nftsWithImageURIs,
      //     });
      //   }
      // }
    } catch (error) {
      console.log("Error => ", error);
    }
  };
